/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BadRequestResponse,
  CreateAccountingLocationResponseResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Create a new Cash Drawer Accounting Location, and creates a safe if none exist for provided fadcode
 */
export const createAccountingLocation = () => {
  return customInstance<CreateAccountingLocationResponseResponse>({
    url: `/bm-accounting-location/v1/`,
    method: 'post',
  });
};

export const getCreateAccountingLocationMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountingLocation>>,
    TError,
    TVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountingLocation>>,
  TError,
  TVariables,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountingLocation>>,
    TVariables
  > = () => {
    return createAccountingLocation();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountingLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountingLocation>>
>;

export type CreateAccountingLocationMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Create a new Cash Drawer Accounting Location, and creates a safe if none exist for provided fadcode
 */
export const useCreateAccountingLocation = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountingLocation>>,
    TError,
    TVariables,
    TContext
  >;
}) => {
  const mutationOptions = getCreateAccountingLocationMutationOptions(options);

  return useMutation(mutationOptions);
};
